import axios from "axios";
import { useDispatch } from "react-redux";
import { server_url } from "../../config";
import { GET_LIKES } from "./types";

export const getViewers = (id, ip) => async (dispatch) => {
  const res = await axios.post(
    `${server_url}/api/viewer/${id}`,
    { ip_address: ip },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  dispatch({
    type: GET_LIKES,
    payload: res.data.data,
  });
};

export const getLike = () => async (dispatch) => {
  const res = await axios.get(`${server_url}/api/likes`);
  dispatch({
    type: GET_LIKES,
    payload: res.data.data,
  });
};

export const like = (id, ip) => async (dispatch) => {
  const res = await axios.post(
    `${server_url}/api/like/${id}`,
    { ip_address: ip },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  dispatch({
    type: GET_LIKES,
    payload: res.data.data,
  });
};
